import $ from "jquery";

// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';


// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay]);


if($('.works__swiper').length) {
  const topSwiper = new Swiper('.works__swiper', {
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      576: {
        slidesPerView: '2',
        spaceBetween: 30,
      },
      1201: {
        slidesPerView: 'auto',
        spaceBetween: 0,
      },
    }
  });
}
// if($('.top__swiper__sp').length) {
//   const topSpSwiper = new Swiper('.top-swiper-sp', {
//     loop: true,
//     speed: 1000,
//     autoplay: {
//       delay: 5000,
//       disableOnInteraction: false,
//     },
//     slidesPerView: 1,
//   });
// }
// if($('.achievement-swiper').length) {
//   const achievementSwiper = new Swiper('.achievement-swiper', {
//     speed: 1000,
//     autoplay: {
//       delay: 5000,
//       disableOnInteraction: false,
//     },
//     slidesPerView: 1,
//     spaceBetween: 15,
//     pagination: {
//       el: '.swiper-pagination',
//       clickable: true,
//     },
//     breakpoints: {
//       576: {
//         slidesPerView: 2,
//         spaceBetween: 20
//       },
//       992: {
//         slidesPerView: 3,
//         spaceBetween: 42
//       },
//     }
//   });
// }
